import apiClient, { handleApiError } from '../../utils/apiClient';

/**
 * 医師一覧APIレスポンス型（snake_case・ページネーション）
 */
interface DoctorListApiResponse {
  data: Array<{
    id: number;
    doctor_code: string;
    first_name: string;
    last_name: string;
    status: string;
  }>;
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

/**
 * 医師（一覧表示用）
 */
export interface Doctor {
  id: number;
  doctorCode: string;
  firstName: string;
  lastName: string;
  status: string;
}

/** 1ページあたりの取得件数（APIの上限値） */
const DOCTORS_PER_PAGE = 100;

/** ページネーションの安全上限ページ数 */
const MAX_PAGES = 50;

/**
 * 医師API（バックエンドAPIとの通信を担当）
 */
export const doctorApi = {
  /**
   * 医師一覧取得（全ページを取得して結合）
   * @param params object 検索条件（status: 契約状況）
   * @returns Promise<Doctor[]> 医師一覧
   */
  fetchDoctors: async (params?: {
    status?: '契約済み' | '解約済み';
  }): Promise<Doctor[]> => {
    try {
      const doctors: Doctor[] = [];
      let page = 1;
      let lastPage = 1;

      do {
        const response = await apiClient.get<DoctorListApiResponse>('/api/doctors', {
          params: {
            page,
            per_page: DOCTORS_PER_PAGE,
            ...(params?.status ? { status: params.status } : {}),
          },
        });

        const { data, meta } = response.data;
        doctors.push(
          ...(data ?? []).map((doctor) => ({
            id: doctor.id,
            doctorCode: doctor.doctor_code,
            firstName: doctor.first_name,
            lastName: doctor.last_name,
            status: doctor.status,
          }))
        );

        lastPage = meta?.last_page ?? 1;
        page += 1;
      } while (page <= lastPage && page <= MAX_PAGES);

      return doctors;
    } catch (error) {
      const errorMessage = handleApiError(error);
      throw new Error(errorMessage);
    }
  },
};

export default doctorApi;
